module.exports = __webpack_public_path__ + "img/parent-child-5.03ae4f06.png";